import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import Login from '@/views/Login.vue'
import Upload from '@/views/Upload.vue'
import Home from '@/views/Home.vue'
import Users from '@/views/Users.vue'
import SelecaoEntidades from '@/views/SelecaoEntidades.vue'
import NotFound from '@/views/NotFound.vue' // Import the 404 page view
import Analises from '@/views/Analises.vue'
import AnalisesCAPAG from '@/views/AnalisesCAPAG.vue'
import Municipios from '@/views/Municipios.vue'
import Balancetes from '@/views/Balancetes.vue'
import FilaAtualizacaoDadosSiconfi from '@/views/FilaAtualizacaoDadosSiconfi.vue'
import FilaCongelamentoPlanilhas from '@/views/FilaCongelamentoPlanilhas.vue'
import FilaProcessamentoArquivosPrevios from '@/views/FilaProcessamentoArquivosPrevios.vue'
import Filas from '@/views/Filas.vue'
import Auditoria from '@/views/Auditoria.vue'
import SolicitarAcesso from '@/views/SolicitarAcesso.vue'
import EsqueciSenha from '@/views/EsqueciSenha.vue'
import Solicitacoes from '@/views/Solicitacoes.vue'
import TrocarSenha from '@/views/TrocarSenha.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/upload',
    name: 'Upload',
    component: Upload
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/selecaoEntidades',
    name: 'SelecaoEntidades',
    component: SelecaoEntidades
  },
  {
    path: '/analises-ranking',
    name: 'AnalisesRanking',
    component: Analises
  },
  {
    path: '/analises-capag',
    name: 'AnalisesCAPAG',
    component: AnalisesCAPAG
  },
  {
    path: '/balancetes',
    name: 'Balancetes',
    component: Balancetes
  },
  {
    path: '/municipios',
    name: 'Municipios',
    component: Municipios
  },
  {
    path: '/filas',
    name: 'Filas',
    component: Filas
  },
  {
    path: '/filas/atualizacao-dados-siconfi',
    name: 'FilaAtualizacaoDadosSiconfi',
    component: FilaAtualizacaoDadosSiconfi
  },
  {
    path: '/filas/congelamento-planilhas',
    name: 'FilaCongelamentoPlanilhas',
    component: FilaCongelamentoPlanilhas
  },
  {
    path: '/filas/processamento-arquivos-previos',
    name: 'FilaProcessamentoArquivosPrevios',
    component: FilaProcessamentoArquivosPrevios
  },
  {
    path: '/auditoria',
    name: 'Auditoria',
    component: Auditoria
  },
  {
    path: '/solicitar-acesso',
    name: 'SolicitarAcesso',
    component: SolicitarAcesso
  },
  {
    path: '/solicitacoes',
    name: 'Solicitacoes',
    component: Solicitacoes
  },
  {
    path: '/trocar-senha',
    name: 'TrocarSenha',
    component: TrocarSenha
  },
  {
    path: '/esqueci-senha',
    name: 'EsqueciSenha',
    component: EsqueciSenha
  },
  {
    path: '/redefinir-senha',
    name: 'RedefinirSenha',
    component: TrocarSenha
  },
  {
    path: '/:pathMatch(.*)*', // Catch all unmatched routes
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const PUBLIC_ROUTES = ['/login', '/solicitar-acesso', '/esqueci-senha', '/redefinir-senha']

router.beforeEach(async (to) => {
  if (PUBLIC_ROUTES.includes(to.path)) {
    return true
  }

  if (!store.state.user) {
    try {
      await store.dispatch('validateToken')
    } catch {
      return { path: '/login' }
    }
  }

  if (store.state.user?.force_password_change && to.path !== '/trocar-senha') {
    return { path: '/trocar-senha' }
  }

  return true
})

export default router
